export default "__VITE_ASSET__0d909c86__"